import type { FC } from 'react';
import React from 'react';
import {
  Paper,
  Typography
} from '@mui/material';

const Quote: FC = (props) => {
  const { children } = props;
  return (
    <Paper
      square
      elevation={0}
      sx={{
        backgroundColor: 'whitesmoke',
        borderLeft: '5px solid #dbdbdb',
        padding: '1.25em 1em',
        my: 3,
      }}
    >
      <Typography color="textSecondary">
        {children}
      </Typography>
    </Paper>
  );
};

export default Quote;
